import axios from "axios";
import {
	BASE_URL,
	AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME as TOKEN_NAME,
} from "@/utils/constants";
import { getLanguage } from "@/i18n";

const client = axios.create({
	baseURL: BASE_URL,
	formSerializer: {
		indexes: null,
	},
	paramsSerializer: {
		indexes: null,
	},
});

// The API picks email, validation and AI language from this. It is the
// language on screen, which for a signed-in user is the account's.
export function buildHeaders({ headers, token, language }) {
	return {
		...headers,
		"Accept-Language": language,
		...(token ? { Authorization: `Bearer ${token}` } : {}),
	};
}

export const request = async (options) => {
	const token = localStorage.getItem(TOKEN_NAME) || "";

	options.headers = buildHeaders({
		headers: options.headers,
		token,
		language: getLanguage(),
	});

	const onSuccess = (response) => {
		return response?.data;
	};

	const onError = (error) => {
		return Promise.reject(error);
	};

	options.timeout = 5000;

	return client(options).then(onSuccess).catch(onError);
};
